<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="单位名称">-->
<!--              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="联系人姓名">-->
<!--              <a-input v-model="queryParam.name" placeholder="搜索联系人姓名"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="审核">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced && false">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
<!--      <a-button @click="download(2)" style="margin-left: 8px">-->
<!--        申报批次导出表-->
<!--        <a-icon type="download"/>-->
<!--      </a-button>-->

      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px;display: inline-block"
      >
        <a-button>
          上传名单
          <a-icon type="upload"/>
        </a-button>
      </a-upload>
      <a-button @click="downloadTpl">
        下载模板
        <a-icon type="download"/>
      </a-button>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="float: left">
            {{ record.year }}<br/>
            {{record.saiqu_name}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
          <a-tag v-if="record.status==1" color="green">审核成功</a-tag>
          <a-tag v-else-if="record.status==2">待审核</a-tag>
        <a-tag v-else>审核失败</a-tag>
      </span>

      <span slot="type" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            <a-tag v-if="record.kaojitype=='考级点'" color="green">
              考级点
            </a-tag>
            <a-tag v-else color="blue">
              考级中心
            </a-tag>

          </div>
      </span>
      <span slot="price" slot-scope="text,record">
          <a-tag v-if="record.kaoji_jiameng_type==1">老政策</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==2">0元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==3">9800元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==4">12万元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==5">13.5万元</a-tag>
            <a-tag v-else>未知</a-tag>
      </span>
      <span slot="jinqun" slot-scope="text,record">
          {{ record.is_jinqun == 1 ? '是' : '否' }}
      </span>
      <span slot="fahuo" slot-scope="text,record">
          {{ record.is_fahuo == 1 ? '已发' : '未发' }}
      </span>
      <span slot="code" slot-scope="text,record">
            {{ record.kaojiregist_code ? record.kaojiregist_code : '(无)' }}
            <br/>
            申请时间 {{ record.create_time|timeFormat }}
            <br/>
        <span v-if="record.recommend_name">推荐加盟人：{{ record.recommend_name }}</span>

      </span>
      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.kaoji_jindu">{{ record.kaoji_jindu|jinduFilter }}</a-tag>

        <a-tag v-if="record.kaojiregist_status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==3" color="purple">审核失败</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==4" color="blue">预审核</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template> 
          <a @click="handleEdit(record)">查看</a>
          <a-divider type="vertical" v-if="record.pdfzipsrc" />
          <a v-if="record.pdfzipsrc" @click="downloadCert(record)">下载证书</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定审核吗?" @confirm="handleShenhe(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">审核</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

            <a-divider>人员信息</a-divider>

          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record">
              {{ record.name }}
              <a-tag v-show="record.code">{{ record.code }}</a-tag>
              <br/>
              {{ record.num }}
            </p>
            <p slot="grade" slot-scope="text,record">
              {{ record.grade }}<br/>
              <!-- <span v-show="record.regist_date>0">注册日期{{ record.regist_date|timeFormat }}</span> -->
            </p>
            <template slot="action" slot-scope="text,record,index">
              <!-- <a href="javascript:;" @click="onEditUser(record)">编辑</a> -->
              <a href="javascript:;" v-show="record.pdfsrc" @click="downloadUserCert(record)">下载证书</a>
              <a-divider type="vertical"/>
            </template>
          </a-table>
          <a-divider>审核信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="审核状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.status" buttonStyle="solid">
                  <a-radio-button :value="2">待审核</a-radio-button>
                  <a-radio-button :value="1">审核通过</a-radio-button>
                  <a-radio-button :value="3">审核失败</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量上传"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'校验成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'校验失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.members.length) "/>
      </p>
      <p v-show="taskInfo.errors.length>0" >存在以下错误，请修正后重新上传 </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="error in taskInfo.errors">{{error}}</p>
        <p v-for="error in taskInfo.errors">{{error}}</p>
        <p v-for="error in taskInfo.errors">{{error}}</p>
      </div>
      <a-progress :percent="taskInfo.percent"/>
      </p>
    </a-modal>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import { message } from 'ant-design-vue';
import 'moment/locale/zh-cn';
import XLSX from 'xlsx'

moment.locale('zh-cn');

import {
  getLevelSpApplyList,
  getLevelSpApplyDetail,
  editLevelSpApply,
  deleteLevelSpApply,
  levelSpShenhe,
  getCenterDownloadUrl,
  levelSpApply
} from '@/api/yundongyuan'
import { 
  sjsqOptions, 
} from '@/api/nlcs'
import setting from "@/config/setting";

export default {
  name: 'LevelApplyList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      saveLoading: false,
      sjsqOptions: [],
      taskInfoShow: false,
      formData: {
        id: 0,
        year: '', name: '', danwei: '', namekey: '', province: '', city: '', county: '', shenfenzheng_pic: [],
        phone: '', weixin: '', email: '', address: '', yundongyuan: []
      },
      taskInfo: {
        members: [],
        errors: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },
      time_range_moment: [],
      time_range: [],
      // 表头
      subjectColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "姓名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "电话",
          dataIndex: "phone",
        },
        {
          title: "微信",
          dataIndex: "weixin",
        },
        {
          title: "等级",
          dataIndex: "grade",
          scopedSlots: { customRender: "grade" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        sjsq:[],
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '年份',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '证书数量',
          dataIndex: 'count',
        },
        {
          title: '申报时间',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        // this.queryParam.namekeys = []
        // this.queryParam.danwei = ''
        // this.queryParam.kaoji_jiameng_type = ''
        // this.queryParam.kaojiregist_status = 0
        this.queryParam = Object.assign(this.queryParam, parameter);

        console.log(this.queryParam)
        return getLevelSpApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
    this.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    downloadCert(record) {
      window.open(setting.apiBaseURL + '/' + record.pdfzipsrc)
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getLevelSpApplyDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')

          res.data.namekeys = [res.data.namekey.substring(0, 2) + '0000', res.data.namekey.substring(0, 4) + '00', res.data.namekey];
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          self.formData = {...res.data};
        }, 200)
      })
    },

    deleteHandle(record) {
      let self = this
      deleteLevelSpApply({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    onCenterDeleteAll() {
      let self = this
      centerDeleteAll({ids: this.selectedRowKeys}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          // province: '', city: '', county: ''

          self.saveLoading = true;
          editLevelSpApply({
            id: self.formData.id,
            namekey: self.formData.namekeys[self.formData.namekeys.length - 1],
            danwei: values.danwei,
            address: values.address,
            year: self.formData.year,
            shenfenzheng_pic: self.formData.shenfenzheng_pic,
            email: values.email,
            phone: values.phone,
            weixin: values.weixin,
            name: values.name,
            status: self.formData.status,
            sstatus: self.formData.sstatus,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },

    download(type) {
      // return
      let params = Object.assign(this.queryParam, {time_range: this.time_range_moment, type: type})
      // console.log('params', params);return
      getCenterDownloadUrl(params)
          .then(res => {
            console.log(res)
            window.open(res.data)
          })
          .catch(err => {
            this.$message.error(err.data.msg)
          })
      return;
      switch (type) {
        case 1:
          // 地区信息表
          window.open(setting.apiBaseURL + '/adminapi/examecenter/centerDownload?saiqu=');
          break;
        case 2:
          // console.log(this.queryParam)
          //   return
          break;
      }
    },

    downloadTpl() {
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1664179097985-5/%E5%85%A8%E5%9B%BD%E5%95%A6%E5%95%A6%E6%93%8D%E6%8A%80%E6%9C%AF%E7%AD%89%E7%BA%A7%E8%BF%90%E5%8A%A8%E5%91%98%E7%94%B3%E8%AF%B7%E8%A1%A8.xlsx.xlsx')
    },
    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      if(this.queryParam.sjsq.length!=2){
            that.$message.error('请先选择场次')
            return;
      }
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)

      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson', tabJson);
          let userList = [];
          tabJson[0].sheet.map((item, index) => {
            if (index > 2 && item.__EMPTY_2) {
              let project = '';
              if (item.__EMPTY_6) {
                project = '花球啦啦操'
              } else if (item.__EMPTY_7) {
                project = '街舞啦啦操'
              } else if (item.__EMPTY_8) {
                project = '技巧啦啦操'
              }
              let grade = '';
              if (item.__EMPTY_9) {
                grade = '一星级'
              } else if (item.__EMPTY_10) {
                grade = '二星级'
              } else if (item.__EMPTY_11) {
                grade = '三星级'
              } else if (item.__EMPTY_12) {
                grade = '四星级'
              } else if (item.__EMPTY_13) {
                grade = '五星级'
              }
              userList.push({
                danwei: item.__EMPTY_1,
                name: item.__EMPTY_2,
                sex: item.__EMPTY_3,
                num: item.__EMPTY_4,
                phone: item.__EMPTY_5 || '',
                email: item.__EMPTY_4 || '',
                weixin: item.__EMPTY_5 || '',
                project: project,
                grade: grade,
                bisaichengji: item.__EMPTY_14 || '',
                bisaidate: item.__EMPTY_15 || '',
                bisaididian: item.__EMPTY_16 || '',
                chengji: item.__EMPTY_17 || '',
                chengjidate: item.__EMPTY_18 || '',
                chengjididian: item.__EMPTY_19 || '',
              });
            }

          })

          console.log('userList', userList);

          // return;

          that.taskInfo = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          }
          // that.taskInfoShow = true;
          that.doTask(that.taskInfo);

        }
      });

      /*
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })*/
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },

    doTask(taskInfo) {
      let that = this;
      console.log(taskInfo.currentIndex, taskInfo.members.length)
      if (taskInfo.currentIndex >= taskInfo.members.length) {
        taskInfo.doing = false;
        //结束
        if (taskInfo.fcount == 0) {
          levelSpApply({
            list: JSON.stringify(taskInfo.members),
            saiji:that.queryParam.sjsq[0],
            saiqu:that.queryParam.sjsq[1],
          }).then(res => {
            that.taskInfoShow = false;
            that.$message.success('上传成功')
            that.$refs.table.refresh(true)
          });
        }
        return false;
      }

      // taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.members.length) * 100).toFixed(1);
      taskInfo.currentIndex = taskInfo.members.length
      taskInfo.fcount = 0
      that.doTask(taskInfo)
    },
    handleShenhe(record){  
      let that = this; 
      const hide = this.$message.loading("审核中，请稍等..", 0);  
          levelSpShenhe({
            id: record.id
          }).then(res => {
            that.taskInfoShow = false;
            that.$message.success("审核成功");  
            setTimeout(hide, 0); 
            that.$refs.table.refresh(true)
          })
          .catch(err => {
            that.$message.error(err.data.msg)
            setTimeout(hide, 0); 
          });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    downloadUserCert(record) {
      window.open(setting.apiBaseURL + "" + record.pdfsrc);
    },

    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
  },
  filters: {
    jinduFilter(value) {
      switch (value) {
        case 1:
          return `联系申报单位`;
        case 2:
          return `告知省级并征求意见+申报单位积极准备中`;
        case 3:
          return `申报单位积极准备中`;
        case 4:
          return `条件已具备，等待验收`;
        case 5:
          return `等待全国啦啦操验收`;
        case 6:
          return `验收并授牌`;
        case 7:
          return `同意考试`;
      }
    },
  },
  watch: {}
}
</script>
